import React from "react";
import {LogoImage} from "./PanelLogo.styles";
import panelLogo from "../../../public/images/vigo-panel-logo.svg";
export const PanelLogo = () => {
    return <LogoImage src={panelLogo} alt="vigo-panel-logo" />;
};
